// @flow

import type {OrderType} from './order-type'
import type {OrderStatus} from './order-status'
import {ContractNumber} from './contract-number'

export type OrderSummary = {
  id: ?number,
  orderDate: ?Date,
  contractNumber: ?ContractNumber,
  orderType: ?OrderType,
  status: ?OrderStatus,
}

const buildOrderSummary = (): OrderSummary => {
  return {
    id: null,
    orderDate: null,
    contractNumber: null,
    orderType: null,
    status: null
  }
}

export {
  buildOrderSummary
}



// WEBPACK FOOTER //
// ./src/types/order-summary.js